/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./_privacy.scss";

const PrivacyGeneral = () => {
  return (
    <div className="w-100 dashboard-childrens">
      <div className="w-100">
        <div className="d-flex">
          <div className="privacy w-100">
            <div className="main">
              <div className="text-center mt-5 mb-3">
                <h1 className="mb-2">
                  Privacy Policy for NexGen Inspector Assistant
                </h1>
                <p className="opacity-50">Effective Date: November 26, 2024</p>
              </div>
              <div className="privacy-policy">
                <p>
                  At <strong>NexGen Inspector Assistant</strong>, we are
                  committed to protecting your privacy and ensuring the security
                  of your personal information. This Privacy Policy outlines how
                  we collect, use, store, and protect the data you provide when
                  using our app (“the App”) and related services.
                </p>
                <p className="mt-2">
                  By downloading, accessing, or using the App, you consent to
                  the terms of this Privacy Policy. If you do not agree with
                  this Privacy Policy, please discontinue use of the App.
                </p>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                <h3>1. Information We Collect</h3>
                <p>
                  When you use the NexGen Inspector Assistant app, we may
                  collect the following types of information:
                </p>
                <h3 style={{ marginLeft: "20px" }}>
                  1.1. Personal Information
                </h3>
                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      Name, email address and other details provided during
                      account creation or subscription
                    </p>
                  </li>
                  <li>
                    <p>
                      Payment details, if applicable, for subscription
                      processing (handled securely by third-party payment
                      processors).
                    </p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }}>1.2. Usage Data</h3>
                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      Information about your interaction with the App, including
                      features used, preferences, and time spent on the App.
                    </p>
                  </li>
                  <li>
                    <p>
                      Device-specific information, such as IP address, device
                      type, operating system, and app version.
                    </p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }}>1.3. Inspection Data</h3>
                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      Notes, prompts, or information you input into the App for
                      report generation.
                    </p>
                  </li>
                  <li>
                    <p>AI-generated outputs based on your inputs.</p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }}>
                  1.4. Cookies and Tracking Technologies
                </h3>
                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      The App may use cookies, pixels, or similar technologies
                      to enhance user experience, track usage, and improve
                      functionality.
                    </p>
                  </li>
                </ul>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>

                <h3>2. How We Use Your Information</h3>

                <p>
                  We use the information collected for the following purposes:
                </p>
                <h3 style={{ marginLeft: "20px" }} className="ml-4">
                  1. To Provide and Improve the App:
                </h3>

                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>Process your inputs to generate AI-driven outputs.</p>
                  </li>
                  <li>
                    <p>
                      Improve the App’s functionality, user interface, and
                      performance.
                    </p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }} className="ml-4">
                  2. To Communicate with You:
                </h3>

                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      Send important updates, service notifications, or
                      promotional materials (if opted in).
                    </p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }} className="ml-4">
                  3. To Ensure Security and Prevent Fraud:
                </h3>

                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      Monitor and analyze app activity to detect and prevent
                      unauthorized access or fraudulent activity.
                    </p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }} className="ml-4">
                  4. To Comply with Legal Obligations:
                </h3>

                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      Fulfill regulatory requirements, resolve disputes, and
                      enforce our terms.
                    </p>
                  </li>
                </ul>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                <h3>3. How We Share Your Information</h3>

                <p>
                  We do not sell, trade, or rent your personal information to
                  third parties. However, we may share information in the
                  following cases:
                </p>
                <h3 style={{ marginLeft: "20px" }} className="ml-4">
                  1. Service Providers:
                </h3>

                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      With third-party providers who assist with payment
                      processing, data storage, and other services necessary for
                      app operations.
                    </p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }} className="ml-4">
                  2. Legal Compliance:
                </h3>

                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      When required by law or to protect our legal rights, we
                      may share information with law enforcement or regulatory
                      authorities.
                    </p>
                  </li>
                </ul>
                <h3 style={{ marginLeft: "20px" }} className="ml-4">
                  3. Aggregated Data:
                </h3>

                <ul style={{ marginLeft: "40px" }}>
                  <li>
                    <p>
                      We may share anonymized or aggregated data that cannot
                      identify you personally, for research or analytical
                      purposes.
                    </p>
                  </li>
                </ul>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* fourth  */}
                <h3>4. Data Storage and Security</h3>

                <p>
                  We take reasonable precautions to protect your personal
                  information from unauthorized access, loss, or misuse.
                </p>

                <ul style={{ marginLeft: "20px" }}>
                  <li>
                    <p>Data is encrypted during transmission and at rest.</p>
                  </li>
                  <li>
                    <p>
                      Access to user information is restricted to authorized
                      personnel.
                    </p>
                  </li>
                  <li>
                    <p>
                      Despite our efforts, no security system is entirely
                      foolproof. By using the App, you acknowledge and accept
                      this risk.
                    </p>
                  </li>
                </ul>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* fifth  */}
                <h3>5. User Responsibilities</h3>

                <p>
                  You are responsible for maintaining the confidentiality of
                  your account credentials. Please notify us immediately if you
                  suspect unauthorized access to your account.
                </p>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* six  */}
                <h3>6. AI-Generated Content Disclaimer</h3>

                <p>
                  The App uses artificial intelligence to generate inspection
                  reports based on user inputs. While we strive to provide
                  accurate and relevant content, AI-generated outputs may
                  occasionally contain errors or inaccuracies.
                </p>

                <ul style={{ marginLeft: "20px" }}>
                  <li>
                    <p>
                      <strong>User Review Required: </strong>All AI-generated
                      content must be reviewed and edited by you before
                      submission to clients or third parties.
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong> No Liability:</strong> We are not responsible for
                      any damages or liabilities arising from reliance on
                      AI-generated content.
                    </p>
                  </li>
                </ul>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* seven  */}
                <h3>7. Data Retention</h3>

                <p>
                  We retain your information for as long as necessary to provide
                  the services or comply with legal obligations. You may request
                  deletion of your data by contacting us at{" "}
                  <a
                    href="mailto:support@nexgeninspectorassistant.com"
                    target="_blank"
                    without
                    rel="noreferrer" className=""
                  >
                    {" "}
                    support@nexgeninspectorassistant.com
                  </a>
                </p>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* eight  */}
                <h3>8. Your Privacy Rights</h3>

                <p>
                  Depending on your location, you may have the following rights
                  regarding your personal information:
                </p>
                <ul style={{ marginLeft: "20px" }}>
                  <li>
                    <p>
                      <strong>Access:</strong> Request access to the personal
                      information we have collected about you.
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>Correction:</strong> Request correction of
                      inaccurate or incomplete data.
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>Deletion:</strong> Request deletion of your
                      personal data, subject to legal and business requirements.
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>Opt-Out:</strong> Opt out of receiving promotional
                      communications.
                    </p>
                  </li>
                </ul>
                <p>
                  To exercise these rights, please contact us at{" "}
                  <a
                    href="mailto:support@nexgeninspectorassistant.com"
                    target="_blank"
                    without
                    rel="noreferrer"
                  >
                    {" "}
                    support@nexgeninspectorassistant.com
                  </a>
                </p>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* none  */}
                <h3>9. Third-Party Links</h3>

                <p>
                  The App may contain links to third-party websites or services.
                  We are not responsible for the privacy practices or content of
                  those third party sites. Please review their privacy policies
                  before sharing your information.
                </p>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* ten  */}
                <h3>10. Changes to This Privacy Policy</h3>

                <p>
                  We may update this Privacy Policy from time to time to reflect
                  changes in our practices or for legal reasons. Updates will be
                  posted on our website and, where necessary, communicated to
                  you. Continued use of the App after changes are posted
                  constitutes your acceptance of the revised policy.
                </p>
                {/* line  */}
                <div
                  className="mt-4 mb-4"
                  style={{
                    background: "rgb(100, 116, 138, 0.3)",
                    height: "2px",
                  }}
                ></div>
                {/* eleven  */}
                <h3>11. Contact Us</h3>

                <p>
                  If you have any questions, concerns, or requests regarding
                  this Privacy Policy, please contact us:
                </p>
                <ul className="mb-4" style={{ marginLeft: "20px" }}>
                  <li>
                    <p>
                      <strong>Website:</strong>
                      <a
                        href="https:www.nexgeninspectorassistant.com"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        {" "}
                        www.nexgeninspectorassistant.com
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>Email:</strong>
                      <a
                        href="mailto:support@nexgeninspectorassistant.com"
                        target="_blank"
                        without
                        rel="noreferrer"
                      >
                        {" "}
                        support@nexgeninspectorassistant.com
                      </a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyGeneral;
